<template>
  <div class="referrals">
    <span class="title">
      <span>🔗</span>
      Referrals
    </span>
    <div class="referral-link">
      <a :href="refLink" @click.prevent="copyRefLink">{{ refLink }}</a>
      <div id="result">{{ result }}</div>
    </div>
    <div class="container">
      <ul class="referral-list" v-if="referrals.length > 0">
        <li class="referral" v-for="referral in paginatedReferrals" :key="referral.email">
          <div class="flex">
            <img src="@/assets/trophy.png" alt="User Icon">
            <span>{{ formatName(referral.name) }}</span>
          </div>
          <div class="flex">
            <img src="@/assets/Fw3P.gif" class="wallet-icon">
            <span>{{ formatBonus(referral.bonus) }}</span>
          </div>
        </li>
      </ul>
      <div v-else class="no-referrals">
        <p>You haven't referred anyone yet.</p>
        <p>Earn 25% of the earnings of your referred users by sharing your referral link!</p>
      </div>
      <div class="pagination" v-if="showPagination">
        <button @click="prevPage" :disabled="currentPage === 1">Previous</button>
        <button @click="nextPage" :disabled="currentPage === totalPages">Next</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ReferralView',
  data() {
    return {
      referrals: [],
      currentPage: 1,
      pageSize: 10,
      refCode: '',
      result: ''
    };
  },
  computed: {
    paginatedReferrals() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.sortedReferrals.slice(start, end);
    },
    sortedReferrals() {
      return [...this.referrals].sort((a, b) => parseFloat(b.bonus) - parseFloat(a.bonus));
    },
    totalPages() {
      return Math.ceil(this.referrals.length / this.pageSize);
    },
    refLink() {
      return `https://t.me/bithermine_bot?start=${this.refCode}`;
    },
    showPagination() {
      return this.referrals.length > this.pageSize;
    }
  },
  methods: {
    fetchReferrals() {
      const telegramId = this.$route.query.telegram_id;
      axios.get(`https://sys.bitherin.com/telegramgetreflist?telegram_id=${telegramId}`)
          .then(response => {
            if (response.data.success) {
              this.referrals = response.data.referrals;
              if (this.referrals.length > 0) {
                this.refCode = this.referrals[0].your_ref_code;
              } else {
                this.fetchRefCode();
              }
            } else {
              console.error('Error fetching referrals:', response.data.message);
              this.fetchRefCode();
            }
          })
          .catch(error => {
            console.error('Error fetching referrals:', error);
            this.fetchRefCode();
          });
    },
    fetchRefCode() {
      const telegramId = this.$route.query.telegram_id;
      axios.get(`https://sys.bitherin.com/telegramgetref?telegram_id=${telegramId}`)
          .then(response => {
            if (response.data.success) {
              this.refCode = response.data.ref_code;
            } else {
              console.error('Error fetching ref code:', response.data.message);
            }
          })
          .catch(error => {
            console.error('Error fetching ref code:', error);
          });
    },
    copyRefLink() {
      const el = document.createElement('textarea');
      el.value = this.refLink;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.result = 'Referral link copied to clipboard!';
      alert('Referral link copied to clipboard!');
    },
    formatName(name) {
      return name.length > 8 ? name.slice(0, 8) + '...' : name;
    },
    formatBonus(bonus) {
      return parseFloat(bonus).toFixed(4);
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    }
  },
  created() {
    this.fetchReferrals();
  }
};
</script>

<style scoped>
.title {
  color: #ffa500;
  font-size: 17px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  letter-spacing: .5px;
}

.referral-link {
  text-align: center;
  margin: 10px 0;
  color: #ffa500;
}

.referral-link a {
  color: #ffa500;
  text-decoration: none;
}

ul {
  padding: 0;
  margin: 0;
}

.referrals {
  text-align: center;
  padding: 20px;
  background-color: #0d1319;
  color: #fff;
  height: 100%;
}

.container {
  padding: 10px 12px;
}

.flex {
  display: flex;
  align-items: center;
  gap: 5px;
}

.referral {
  padding: 10px 8px;
  border-bottom: 2px solid #040C14;
  border-radius: 3px;
  display: grid;
  grid-template-columns: 3fr 1fr 1fr;
}

.referral:nth-child(even) {
  background-color: #020202;
}

.referral-list {
  margin-top: 15px;
}

.no-referrals {
  text-align: center;
  color: #ffa500;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.pagination button {
  margin: 0 5px;
  padding: 5px 10px;
  border: 1px solid #040C14;
  background: linear-gradient(to right, #ffa500, #ff4500);
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.wallet-icon {
  width: 20px;
}
</style>
